/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class BooleanFilters {
  'is'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "is",
      "baseName": "is",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BooleanFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

